import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.138 8.745C13.683 8.25 19.292 8 23.968 8c4.679 0 10.31.249 16.893.746a5 5 0 0 1 4.591 4.423C45.818 16.394 46 20.003 46 24c0 3.263-.121 6.268-.365 9.016a7 7 0 0 1-6.476 6.365c-5.794.413-10.825.619-15.094.619-4.28 0-9.354-.208-15.221-.622a7 7 0 0 1-6.48-6.365C2.122 30.266 2 27.262 2 24c0-3.997.182-7.607.548-10.832a5 5 0 0 1 4.59-4.423Zm-1.65 2.775-.08.12-.019.026c-.025.038-.05.075-.039.054a1.84 1.84 0 0 0 .747 2.493l16.406 8.846a2.822 2.822 0 0 0 1.497.357l.038.001c.51.014.982-.101 1.46-.358l16.405-8.846a1.84 1.84 0 0 0 .747-2.493c.01.021-.014-.016-.039-.053a9.442 9.442 0 0 0-.097-.144 2.994 2.994 0 0 0-1.804-.782C34.173 10.247 28.591 10 23.968 10c-4.62 0-10.181.246-16.68.74a2.994 2.994 0 0 0-1.8.78Zm38.175 3.87c-.238.224-.51.42-.81.583L26.445 24.82a4.819 4.819 0 0 1-2.446.598 4.819 4.819 0 0 1-2.446-.598L5.148 15.973a3.846 3.846 0 0 1-.81-.583C4.111 18.014 4 20.885 4 24c0 3.205.12 6.15.357 8.836a5 5 0 0 0 4.628 4.547c5.823.411 10.85.617 15.08.617 4.217 0 9.202-.205 14.952-.614a5 5 0 0 0 4.626-4.546C43.88 30.153 44 27.206 44 24c0-3.115-.112-5.986-.337-8.61Z",
    fill: "currentColor"
  }));
};

var SvgMail = styled(SvgComponent).withConfig({
  displayName: "Mail__SvgMail",
  componentId: "sc-138pgmq-0"
})(["", " ", ""], size, color);
export default SvgMail;